if (typeof BSS_B2B) {
    if (window.location.pathname.includes("/products/")) {
        setTimeout(() =>{
            const targetProduct = document.querySelector('#product-form-installment input[name="id"]');
            if (targetProduct) {
                const mutationObserver = new MutationObserver((recordList, observe) => {
                    setTimeout(() =>{
                        const productForm = document.querySelector("[bss-b2b-main-product-form]");
                        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
                    }, 500)
                });
                mutationObserver.observe(targetProduct, { attributes: true });
            }
        }, 2000)
    }

    //quickview
    setTimeout(() => {
        let quickViewBtn = document.querySelectorAll(".product-card--add-to-cart-button");
        if (quickViewBtn.length) {
            for (let i = 0; i < quickViewBtn.length; i++) {
                quickViewBtn[i].onclick = function () {
                    setTimeout(function () {
                        const productForm = document.querySelector(
                            "[bss-b2b-quickview-product-form]"
                        );
                        if (productForm) {
                            productForm.removeAttribute("bss-b2b-product-form");
                            productForm.removeAttribute("bss-b2b-observer-id");
                            productForm.removeAttribute("bss-b2b-product-form-id");
                        }
                        document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
                        const variantInput = productForm.querySelector('#product-form-installment input[name="id"]');
                        const changeVariant = (mutations) => {
                            setTimeout(() => {
                                BSS_B2B.observer.productSubject.notifyObserver("VariantChange", "VariantSelectChange", {
                                    productForm,
                                });
                            }, 500);
                        };
                        const observer = new MutationObserver(changeVariant);
                        observer.observe(variantInput, {
                            attributes: true,
                        });
                    }, 2000);
                };
            }
        }
    }, 3000);

    
  
}